import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Container = styled.div`
    background:#fff;
    padding:14px;
    border-radius: 10px;
    box-shadow: 0 1px 4px 2px rgba(0,0,0,0.1);
    position: relative;
    height:100%;
    aspect-ratio: 1 / 1.3;

    ${mq(Devices.tablet)}{
        max-height: auto;
        aspect-ratio: 1 / 1.3;
    }
    ${mq(Devices.laptop)}{
        grid-column: auto / span 2;
    }
`;

export const TopTitle = styled.div`
    font-size: 18px;
    font-weight: 500;
    display:flex;
    align-items: center;
    padding:0 10px;
`;

export const BT = styled.div`
    font-size: 14px;
    color:#2A848E;
    position: absolute;
    bottom:14px;
    left: 0;
    width:100%;
    text-align: center;
    :hover{
        opacity: 0.8;
        cursor: pointer;
    }
`;

export const ListContainer = styled.div`
    margin-top: 10px;
    display:flex;
    flex-direction: column;
    gap:10px;
    max-height: calc(100% - 60px);
    overflow-y: auto;
    padding:2%;
    height:100%;

    ${mq(Devices.tablet)}{
        max-height: auto;
        /* overflow-y: unset; */
        padding:0;
        max-height: calc(100% - 76px);
    }

    svg{
        width:30
    }
`;

export const ListItem = styled.div`
    display:grid;
    grid-template-columns: 36px auto;
    gap:10px;
    box-shadow: 0 0 2px rgba(0,0,0,0.3);
    border-radius: 8px;
    padding:12px;
    position: relative;
    font-size: 14px;
    cursor: pointer;
`;

export const ImageContainer = styled.div`
    position: relative;
    width:36px;
    height:36px;
    overflow: hidden;
    border-radius: 50%;
    > div{
        border-radius: 50%;
    }
`;

export const ItemInfo = styled.div`
    > div{
        display:flex;
        align-items: center;
        gap:8px;

    
        > svg{
            height:12px;
        }
    }

    span{
        b{
            color:#4d4d4d;
        }
    }

`;

export const ItemName = styled.div`
    font-size: 16px;
    padding-right: 60px;
`;

export const TagPill = styled.div<{PColor?:string, big?:boolean}>`
    right:12px;
    top:12px;

   background:${props => props.PColor};
   color:#fff;
   border-radius: 30px;
   padding:2px 8px;
   font-size:  10px;
`;

// export const BT = styled.div`
    
// `;

// export const BT = styled.div`
    
// `;

